var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59689 7.48671C6.30523 7.48671 6.07461 7.71337 6.07461 8.00004C6.07461 8.28004 6.30523 8.51337 6.59689 8.51337H10.6667V11.7C10.6667 13.3334 9.31686 14.6667 7.64825 14.6667H4.34496C2.68313 14.6667 1.33333 13.34 1.33333 11.7067V4.30004C1.33333 2.66004 2.68992 1.33337 4.35174 1.33337H7.66182C9.31686 1.33337 10.6667 2.66004 10.6667 4.29337V7.48671H6.59689ZM13.0868 5.69351L15.0335 7.63351C15.1335 7.73351 15.1868 7.86017 15.1868 8.00017C15.1868 8.13351 15.1335 8.26684 15.0335 8.36017L13.0868 10.3002C12.9868 10.4002 12.8535 10.4535 12.7268 10.4535C12.5935 10.4535 12.4601 10.4002 12.3601 10.3002C12.1601 10.1002 12.1601 9.77351 12.3601 9.57351L13.4268 8.51351H10.6668V7.48684H13.4268L12.3601 6.42684C12.1601 6.22684 12.1601 5.90017 12.3601 5.70017C12.5601 5.49351 12.8868 5.49351 13.0868 5.69351Z",
    fill: "#344054"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.791671465a5706f442851ab86244d1c7.svg";
export { ForwardRef as ReactComponent };